module.exports = __webpack_public_path__ + "images/checkbox-tick-square.svg";